/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Checkbox, FlexContainer, Text, theme } from "@nordcloud/gnui";
import { FilterProps } from "./types";

function ResourceLifeSpanCheckbox({ filters, setFilters }: FilterProps) {
  return (
    <>
      <FlexContainer marginTop={theme.spacing.spacing04}>
        <div>
          <Checkbox
            withoutLabel
            id="checkbox-id"
            checked={filters.lifeSpanExclude}
            onChange={() =>
              setFilters({
                ...filters,
                lifeSpanExclude: !filters.lifeSpanExclude,
              })
            }
          />
        </div>
        <Text
          style={{
            marginLeft: theme.spacing.spacing02,
            marginBottom: theme.spacing.spacing00,
          }}
        >
          Exclude from resources
        </Text>
      </FlexContainer>
    </>
  );
}

export default ResourceLifeSpanCheckbox;
